import { createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../helper/axiosInstance";

const initialState = {
  getActivityLogsLoading: false,
  activityLogs: [],
  activityLogsTotal: 0,
  activityLogsError: null,
};

export const activityLogSlice = createSlice({
  name: "activityLog",
  initialState,
  reducers: {
    getActivityLogs: (state) => {
      state.getActivityLogsLoading = true;
      state.activityLogsError = null;
    },
    getActivityLogsSuccess: (state, action) => {
      state.getActivityLogsLoading = false;
      state.activityLogs = action.payload?.data || [];
      state.activityLogsTotal = action.payload?.total || 0;
    },
    getActivityLogsFailed: (state, action) => {
      state.getActivityLogsLoading = false;
      state.activityLogs = [];
      state.activityLogsTotal = 0;
      state.activityLogsError = action.payload || "Failed to fetch logs";
    },
  },
});

export const {
  getActivityLogs,
  getActivityLogsSuccess,
  getActivityLogsFailed,
} = activityLogSlice.actions;

export const getActivityLogsAsync =
  (date, module, page = 1, perPage = 20, search = "") =>
  (dispatch) => {
    dispatch(getActivityLogs());
    axiosInstance
      .get("/ActivityLog/GetLogs", {
        params: { date, module, page, perPage, search },
      })
      .then((response) => {
        dispatch(getActivityLogsSuccess(response?.data));
      })
      .catch((err) => {
        dispatch(getActivityLogsFailed(err?.response?.data?.message));
      });
  };

export default activityLogSlice.reducer;
